import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
// 引入flexible插件:移动端自适应
import rem from 'amfe-flexible'
//引入vant布局插件
import 'vant/lib/index.css'
import { Col, Row ,Image,loading,Dialog,Toast   } from 'vant';
import vueAplayer from 'vue-aplayer';

Vue.use(rem);
Vue.use(Col);
Vue.use(Row);
Vue.use(Image);
Vue.use(vueAplayer);
Vue.use(loading);
Vue.use(Dialog);
Vue.use(Toast);

// 配置axios请求的基础路径
// axios.defaults.baseURL = "http://127.0.0.1:8084"
// 将axios放入vue的原型对象中
// Vue.prototype.axios = axios
// 结果：将来所有的组件中都可以用this.axios发送请求

Vue.config.productionTip = false

new Vue({    
  router,
  store,
  render: h => h(App)    // render加载，把app.vue的内容挂在到index.html的#app中去
}).$mount('#app')
